<template>
    <v-btn @click="onClick"
           :disabled="isDisabled"
           ref="show-semi-fullscreen-button"
           content="Full Browser View"
           v-tippy>
        <v-icon class="material-icons">aspect_ratio</v-icon>
    </v-btn>
</template>

<script>

import { mapState } from "vuex";

export default {
    mounted() {
        this.$root.$refs.showSemiFullscreenButton = this.$refs['show-semi-fullscreen-button']
    },

    computed: {
        ...mapState('Projects', ['image']),
        isDisabled() {
            return !this.image;
        }
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;
            window.UI.enterSemiFullscreen();
        },
    },
};
</script>
